import { Card, Typography, Grid, Box, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { maskCurrency } from 'src/utils/formatNumber'

export default function DataCollapse({ study }: any) {

	return <Card>
		<Grid container direction={'column'}>
			<Box m={2} bgcolor={'#F4F6F8'} borderRadius={2} height={50}>
				<Grid container direction={'row'} mt={1.5}>
					<Grid item xs={8} alignItems={'center'} spacing={2}>
						<Typography color={'#637381'} textAlign='center' mr={14}>
							<b>Informações de produto</b>
						</Typography>
					</Grid>
					<Grid item xs={4} alignItems={'flex-start'}>
						<Typography color={'#637381'} textAlign='flex-start'>
							<b>Dado</b>
						</Typography>
					</Grid>
				</Grid>
			</Box>
			<Box m={2} mb={6}>
				<Grid container direction={'row'} ml={-1} spacing={4}>
					<Grid item xs={7}>
						<Typography>
							Produto
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.openLot ? "Loteamento aberto " : "")} {(study?.controledLot ? "Loteamento de acesso controlado " : "")} {(study?.closedCon ? "Condominio fechado " : "")} {(study?.housesCon ? "Condominio de casas construidas " : "")} {study?.other}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área Total
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{study?.area}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Perimetro Total
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{study?.perimeter}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Padrão do empreendimento
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.enterprise_standard === 'A' ? "Alto" : (study?.enterprise_standard === 'B' ? "Médio" : "Baixo"))}
						</Typography>
					</Grid>
					<Grid item xs={12} ml={-2} mt={-2} mb={-2}>
						<Accordion
							sx={{
								boxShadow: "none !important",
								backgroundColor: "#FFF",
								":before": { display: "none" },
							}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon sx={{ justifySelf: 'left' }} />}
								sx={{
									justifyContent: 'flex-start',
									'.MuiAccordionSummary-content': {
										flexGrow: 'inherit'
									}
								}}
							>
								<Typography>Briefing</Typography>
							</AccordionSummary>
							<AccordionDetails sx={{ backgroundColor: "#fff" }}>
								{study?.description}
							</AccordionDetails>
						</Accordion>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Aquisição
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.aquisition === 'no' ? "Não" : "Sim")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Valor de aquisição
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.aquisition === 'no' ? "-" : study?.dataHelper?.glebaValue)}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Região litorânea
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.litorianReg === 'no' ? "Não" : "Sim")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							ETE
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.efluentTreatment === 'no' ? "Não" : "Sim")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Pavimentação
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.pavimentation === 'block' ? "Bloco" : "Asfalto")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Topografia
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.predomTopo === 'waved' ? "Ondulada" : (study?.dataHelper?.predomTopo === 'bumpy' ? "Acidentada" : "Plana"))}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Solo
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.predomGroud === 'clayish' ? "Argiloso" : (study?.dataHelper?.predomGroud === 'rock' ? "Dec. Rocha" : "Arenoso"))}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Lançamento Pluvial
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.rainRelease === 'next' ? "Próximo" : (study?.dataHelper?.rainRelease === 'distant' ? 'Distante' : 'Local'))}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Arquiteturas
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.architecture === 'no' ? "Não" : "Sim")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Área das arquiteturas
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.architecture === 'no' ? "-" : study?.dataHelper?.architecture_area)}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Reservatórios
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.reservatory === 'no' ? "Não" : "Sim")}
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Permutas
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.permut || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Impostos sobre VGV
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.vgvFees || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Corretagem
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{(study?.dataHelper?.brokerage || 0)}%
						</Typography>
					</Grid>
					<Grid item xs={7}>
						<Typography>
							Valor de Venda do m²
						</Typography>
					</Grid>
					<Grid item xs={5}>
						<Typography>
							{typeof study?.dataHelper?.sellPriceMeter ===  'string' ? study?.dataHelper?.sellPriceMeter : maskCurrency(study?.dataHelper?.sellPriceMeter || 0)}
						</Typography>
					</Grid>
					<Grid item xs={12} ml={-2} mt={-2} mb={-2}>
						<Accordion
							sx={{
								boxShadow: "none !important",
								backgroundColor: "#FFF",
								":before": { display: "none" },
							}}
						>
							<AccordionSummary
								expandIcon={<ExpandMoreIcon sx={{ justifySelf: 'left' }} />}
								sx={{
									justifyContent: 'flex-start',
									'.MuiAccordionSummary-content': {
										flexGrow: 'inherit'
									}
								}}
							>
								<Typography>Outras informações</Typography>
							</AccordionSummary>
							<AccordionDetails sx={{ backgroundColor: "#fff" }}>
								{study?.dataHelper?.otherInfos}
							</AccordionDetails>
						</Accordion>
					</Grid>
				</Grid>
			</Box>
		</Grid>
	</Card>
}